import React from 'react';

function Loading() {
  return (
    <div className="center-text">
      <div className="process-box-intro">
        <div className="process-box-content">Loading...</div>
      </div>
    </div>
  );
}

export default Loading;
